module.exports = __webpack_public_path__ + "static/img/rating-C.20fbbf1.png";